import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { emailUnsubscribeRoutes } from "./routes";

export const emailUnsubscribeRoute = [
  {
    path: emailUnsubscribeRoutes.aiUpdateList,
    lazy: async () => {
      const { AiEmailUpdateUnsubscribePage } = await import("./pages/AiEmailUpdateUnsubscribePage");

      return { element: <AiEmailUpdateUnsubscribePage /> };
    },
  },
  {
    path: emailUnsubscribeRoutes.aiUpdateDetails,
    lazy: async () => {
      const { AiEmailUpdateUnsubscribePage } = await import("./pages/AiEmailUpdateUnsubscribePage");

      return { element: <AiEmailUpdateUnsubscribePage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
